module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Stamp-d0758ac72bb1a24d0fdd0ca91da1836a.svg";